import { useEffect, useState } from 'react'
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { CloseIconButton } from '../Utilities'
import FormField, { EMAIL_REGEX } from './FormField'

// Optional email-input dialog for logged-in users without an email on their Keycloak profile shown before kicking off a custom timelapse generation
export default function TimelapseEmailDialog({ open, onClose, onSubmit }) {

    const { t } = useTranslation()

    const [email, setEmail] = useState('')

    // reset when the dialog reopens so a stale value from a previous turn doesn't leak in
    useEffect(() => {
        if (open) setEmail('')
    }, [open])

    const trimmed = email.trim()
    const isInvalidEmail = !!(trimmed && !EMAIL_REGEX.test(trimmed))

    const handleSubmit = () => {
        if (isInvalidEmail) return
        onSubmit(trimmed)
    }

    const handleSkip = () => onSubmit('')

    return (
        <Dialog
            open={open}
            onClose={onClose}
            PaperProps={{ sx: { maxWidth: 420, width: '100%' } }}
        >
            <CloseIconButton onClick={onClose} />

            <DialogTitle sx={{ userSelect: 'none', fontSize: '1.3rem', pr: 5 }}>
                {t('timelapse.email_dialog.title')}
            </DialogTitle>

            <DialogContent sx={{ pb: 0 }}>
                <Typography sx={{ pb: 2, userSelect: 'none' }}>
                    {t('timelapse.email_dialog.description')}
                </Typography>

                <FormField
                    id="timelapse-email"
                    type="email"
                    label={t('timelapse.email_dialog.placeholder')}
                    value={email}
                    onChange={(event) => setEmail(event.target.value)}
                    onKeyDown={(event) => {
                        if (event.key === 'Enter') {
                            event.preventDefault()
                            handleSubmit()
                        }
                    }}
                    validate="email"
                    autoFocus
                />
            </DialogContent>

            <DialogActions sx={{ px: 3, pb: 2, pt: 0, justifyContent: 'space-between' }}>
                <Button onClick={handleSkip} variant="outlined">
                    {t('timelapse.email_dialog.skip')}
                </Button>
                <Button onClick={handleSubmit} variant="contained" disabled={isInvalidEmail}>
                    {t('timelapse.email_dialog.submit')}
                </Button>
            </DialogActions>
        </Dialog>
    )
}
